import { useNavigate } from 'react-router-dom';
import { chartMap } from '../components/ChartMap';
import { Typography, Paper, Grid } from '@mui/material';

const SalesDashboardPage = () => {
    const navigate = useNavigate();

    return (
        <>
            <Typography variant="h1" mb={2}>データ分析</Typography>

            <Grid container spacing={1}>
                {Object.entries(chartMap).map(
                    ([key, { component: ChartComponent, label, slug }]) => (
                        <Grid item xs={12} md={6} key={key}>
                            <Paper
                                variant="section"
                                sx={{
                                    height: '100%',
                                    cursor: 'pointer',
                                }}
                                onClick={() => navigate(`/chart/${slug}`)}
                            >
                                <ChartComponent />
                            </Paper>
                        </Grid>
                    )
                )}
            </Grid>
        </>
    );
};

export default SalesDashboardPage;
